import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Field pattern of the GTFS provider screens: label (12px semibold ink-2) →
 * 6px → the projected 48px control → helper (12px ink-3, or danger when
 * `error` is set). The shared `app-form-field` uses semibold ink-2 helper text
 * with 8px gaps, which the other provider types keep.
 *
 *   <app-gtfs-field [label]="t('…')" [help]="t('…')" [error]="err">
 *     <app-text-input … />
 *   </app-gtfs-field>
 */
@Component({
  selector: 'app-gtfs-field',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: { class: 'block min-w-0' },
  template: `
    <div class="flex flex-col gap-1.5">
      @if (label()) {
        <span class="text-[12px] font-semibold leading-4" [class.text-danger]="danger()" [class.text-ink-2]="!danger()">{{ label() }}</span>
      }
      <ng-content />
      @if (error()) {
        <span class="text-[12px] leading-4 text-danger">{{ error() }}</span>
      } @else if (help()) {
        <span class="text-[12px] leading-4" [class.text-danger]="danger()" [class.text-ink-3]="!danger()">{{ help() }}</span>
      }
    </div>
  `,
})
export class GtfsFieldComponent {
  readonly label = input('');
  readonly help = input('');
  /** Shown instead of `help`, in danger colour. */
  readonly error = input<string | null>(null);
  /** Label and helper in danger colour without replacing the helper text
   *  (e.g. an unrecognised stored value that needs fixing). */
  readonly danger = input(false);
}
